@if (utilitiesPages$ | async; as pages) {
    @if (pages.length > 0) {
        @if (position === 'mobile') {
            @for (page of pages; track page.id) {
                @if (page.children && page.children.length > 0) {
                    <!-- On mobile, utilities pages with children render as an expanded list -->
                    <li class="nav-item">
                        <a (click)="navigateToPage(page)" class="nav-link fw-bold" href="javascript:void(0)">
                            {{ page.meta?.['friendlyPageName'] || page.name }}
                        </a>
                    </li>
                    @for (child of page.children; track child.id) {
                        @if (showInMenu(child, 'no-child')) {
                            <li class="nav-item ps-3">
                                <a (click)="navigateToPage(child)" class="nav-link" href="javascript:void(0)">
                                    {{ child.meta?.['friendlyPageName'] || child.name }}
                                </a>
                            </li>
                        }
                    }
                } @else {
                    <li class="nav-item">
                        <a (click)="navigateToPage(page)" class="nav-link" href="javascript:void(0)">
                            {{ page.meta?.['friendlyPageName'] || page.name }}
                        </a>
                    </li>
                }
            }
        } @else {
            <div
                class="top-nav-utilities"
                [class.dark-mode]="darkMode"
                [class.utility-above]="position === 'above'"
                [class.utility-below]="position === 'below'"
                [style.background-color]="bgColor"
                [style.--utilities-nav-text-color]="navTextColor"
                [style.--utilities-nav-hover-color]="navHoverColor">
                <div class="container--nav h-100">
                    <div class="d-flex align-items-center justify-content-end h-100">
                        <ul class="utilities-nav-list m-0 p-0 d-flex list-unstyled">
                            @for (page of pages; track page.id) {
                                @if (page.children && page.children.length > 0) {
                                    <li class="utilities-nav-item dropdown" dropdown>
                                        <a
                                            href="javascript:void(0)"
                                            class="utilities-nav-link dropdown-toggle text-decoration-none"
                                            dropdownToggle>
                                            {{ page.meta?.['friendlyPageName'] || page.name }}
                                        </a>
                                        <div *dropdownMenu class="dropdown-menu dropdown-menu-end">
                                            <!-- Parent item link at the top of the flyout menu -->
                                            @if (addParentPageToUtilityMenu) {
                                                <a
                                                    href="javascript:void(0)"
                                                    (click)="navigateToPage(page)"
                                                    class="dropdown-item">
                                                    {{ (page.meta?.['friendlyPageName'] || page.name) + ' Overview' }}
                                                </a>
                                            }
                                            @for (child of page.children; track child.id) {
                                                @if (showInMenu(child, 'no-child')) {
                                                    <a
                                                        href="javascript:void(0)"
                                                        (click)="navigateToPage(child)"
                                                        class="dropdown-item">
                                                        {{ child.meta?.['friendlyPageName'] || child.name }}
                                                    </a>
                                                }
                                            }
                                        </div>
                                    </li>
                                } @else {
                                    <li class="utilities-nav-item">
                                        <a
                                            href="javascript:void(0)"
                                            (click)="navigateToPage(page)"
                                            class="utilities-nav-link text-decoration-none">
                                            {{ page.meta?.['friendlyPageName'] || page.name }}
                                        </a>
                                    </li>
                                }
                            }
                        </ul>
                    </div>
                </div>
            </div>
        }
    }
}
